
<div class="hidden-xs chat-cont first-step-bs text-center chatVisible" (click)="this.chat()">
	<a class="chatelement hidden-xs hidden-sm">
      <span class="chate-icon text-center">
          <img width="100%" src="../../assets/images/atenicon.png">
      </span>
      <span class="chate-t text-center">
          Chat<br/>
          Asistente<br/>
          Virtual
      </span>
  </a>
</div>